'use strict'
const modal = {
	el: {
		btnsTriggerModal: document.querySelectorAll('.js-open-modal'),
		modals: document.querySelectorAll('.js-modal'),
		modalOverlay: document.querySelector('.js-modal-overlay'),
		btnsCloseModal: document.querySelectorAll('.js-close-modal'),
		body: document.body
	},

	vars: {
		pagesFlow: ['tem-cartao', 'selecionar-cartao']
	},

	fxOpenModal(event, element) {
		const modalType = element.dataset.modal ? element.dataset.modal : 'gpf',
			modalContainer = document.querySelector(`.js-modal[data-modal='${modalType}']`)

		event.preventDefault()
		modalContainer.classList.add('open')

		//gpf modal
		if(modalType === 'gpf') {
			const tabs = modalContainer.querySelectorAll('.tab-content'),
				formContainer = modalContainer.querySelectorAll('.jq_tab-content'),
				forms = modalContainer.querySelectorAll('form')
	
			for (const form of forms) {
				form.reset()
			}
	
			tabs.forEach(el => {
				el.dataset.operation === element.dataset.tab ? el.classList.add('selected') : el.classList.remove('selected')
			})
	
			formContainer.forEach(el => {
				el.dataset.container === element.dataset.tab ? el.classList.remove('d-none') : el.classList.add('d-none')
			})
		}
		
		!this.el.modalOverlay.classList.contains('active') && this.fxToggleOverlay()
		!this.el.body.classList.contains('no-scroll-hidden') && this.el.body.classList.add('no-scroll-hidden')
	},

	fxToggleOverlay() {
		this.el.modalOverlay.classList.toggle('active')
	},

	fxCloseModal(element, closeOverlay = true) {
		const modal = element.closest('.modal')
		
		modal.classList.remove('open')
		modal.classList?.remove('open-static')

		if(closeOverlay) {
			this.fxToggleOverlay()
			this.el.body.classList.remove('no-scroll-hidden')
		}
	},

	fxShowModalFlow (page, modal) {
		if(window.location.pathname.indexOf(page) > -1 && modal.dataset.modal === 'flow') {
			modal.classList.add('open')
			this.el.body.classList.add('no-scroll-hidden')
			this.el.modalOverlay.classList.add('active')
		}
	},

	events () {
		for(const btn of this.el.btnsTriggerModal) {
			btn.addEventListener('click', e => this.fxOpenModal(e, e.currentTarget))
		}

		for(const btn of this.el.btnsCloseModal) {
			btn.addEventListener('click', e => this.fxCloseModal(e.currentTarget))
		}
	},

	init () {
		//show modal on specific pages ex: login, error
		for(const modal of this.el.modals) {
			for (const page of this.vars.pagesFlow) {
				this.fxShowModalFlow(page, modal)
			}
		}
		
		if(this.el.btnsTriggerModal.length === 0 || !this.el.btnsCloseModal) return
		this.events()
	}
}

modal.init()